type GetUrlParams = (
  pathname: string,
) => [basename: string, storeName: string, sessionId: string]

export const getUrlParams: GetUrlParams = (pathname) => {
  const isEphemeralEnv = process.env.REACT_APP_EPHEMERAL === 'true'

  const pathNameAsArray = pathname.split('/')

  const [basename, storeName, sessionId] = isEphemeralEnv
    ? pathNameAsArray.splice(1, 3)
    : pathNameAsArray
  return [basename || '/', storeName, sessionId]
}

export default getUrlParams
